import { jsx } from 'react/jsx-runtime';
import { makeStyles, createStyles, CircularProgress } from '@material-ui/core';

var useLoadingStyles = makeStyles(function (theme) {
    return createStyles({
        spinnerContainer: {
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'center',
            height: '100%',
            position: 'static',
            width: '100%'
        },
        asCover: {
            position: 'absolute',
            top: 0,
            left: 0,
            zIndex: 10
        }
    });
});
var LoadingData = function (_a) {
    var overlapParent = _a.overlapParent,
        shiftTop = _a.shiftTop;
    var classes = useLoadingStyles();
    return jsx("div", { className: "".concat(classes.spinnerContainer, " ").concat(overlapParent ? classes.asCover : ''), children: jsx(CircularProgress, { style: { marginTop: "".concat(shiftTop, "px") } }) });
};

export { LoadingData as L };
